
export default {
  props: {
    resources: {
      type: Array,
      required: true,
    },
  },
}
